import axios from 'axios';
import { isRefusedRequest } from './isRefusedRequest';

export function isFailedRequest(error: unknown): boolean {
  return axios.isAxiosError(error) && !isRefusedRequest(error);
}
